// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;For great is his steadfast love towards us,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the faithfulness of the Lord endures for ever.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Alleluia.<br> </p> </div></div>";
// Exports
module.exports = code;